import { handleActions, handleAction } from "redux-actions";
import {
  AUTH,
  SET_PROFILE,
  SET_CURRENT_ROUTE,
  LOGOUT,
  SHOW_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_SIDE_MENU_STATE,
  OPEN_ALERT_FORM,
  CLOSE_ALERT_FORM,
  EDIT_SELECTED_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  SET_ALERT_LIST,
  ADD_NEW_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  THEME,
  FETCH_REPCON,
  FETCH_NAVPRODUCTS,
} from "./../../constants";
import { createCrudReducers } from "../../utils/crudGenerator";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

export const repcon = handleActions(
  {
    [FETCH_REPCON]: (state, action) => action.payload,
  },
  null
);

export const navProducts = handleActions(
  {
    [FETCH_NAVPRODUCTS]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) => action.payload,
  {}
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  false
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

const userReducers = createCrudReducers("USER");

export const users = userReducers.list;
export const usersForm = userReducers.form;

const rawmaterialReducers = createCrudReducers("RAWMATERIAL");

export const rawmaterials = rawmaterialReducers.list;
export const rawmaterialsForm = rawmaterialReducers.form;
const zoneReducers = createCrudReducers("ZONE");

export const zones = zoneReducers.list;
export const zonesForm = zoneReducers.form;
const machineReducers = createCrudReducers("MACHINE");

export const machines = machineReducers.list;
export const machinesForm = machineReducers.form;
const finishedproductReducers = createCrudReducers('FINISHEDPRODUCT');

export const finishedproducts = finishedproductReducers.list;
export const finishedproductsForm = finishedproductReducers.form;
const clientReducers = createCrudReducers("CLIENT");

export const clients = clientReducers.list;
export const clientsForm = clientReducers.form;

const clientproductReducers = createCrudReducers('CLIENTPRODUCT');

export const clientproducts = clientproductReducers.list;
export const clientproductsForm = clientproductReducers.form;
